import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const AtgolorsdataapiPage = () => (
  <MarkdownPage file="DataGateway.md" />
);
